<style scoped>
  .el-collapse-item__header {
      padding-left: 15px;
  }
  .el-upload--picture-card {
    float: left;
    margin-right: 10px;
} 
  .circle-closesty {
      position: relative;
    top: -35px;
    margin-left: 112px;
    font-size: 20px;
    cursor: pointer;
  }
  .v-modal {
    z-index: 100 !important;
  }
  .ipt-sty{
    width: 67%!important;
  }
  .el-col-6{
    width: 30%;
  }
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6"
          ><div class="search-area-div w110">人员：</div>
          <el-input v-model="page.staffName" class="ipt-sty" placeholder="请输入人员"></el-input
        ></el-col>
        <el-col :span="6" >
        <div class="search-area-div w110">签约/参保公司：</div>
          <el-select v-model="page.insuredCompanyGuid" placeholder="请选择" class="ipt-sty" filterable clearable>
            <el-option 
              v-for="item in tenantListDz"
              :key="item.guid"
              :label="item.tenantName"
              :value="item.guid">
            </el-option>
          </el-select>
          </el-col>  
          <el-col :span="6" >
        <div class="search-area-div w110">社保状态：</div>
          <el-select v-model="page.insuranceState" placeholder="请选择" class="ipt-sty" clearable>
            <el-option 
              v-for="item in fundStateList"
              :key="item.value"
              :label="item.label" 
              :value="item.value">
            </el-option>
          </el-select>
          </el-col>  
          </el-row>
          <el-row :gutter="24" class="mt15">
          <el-col :span="6">
          <div class="search-area-div w110">代缴公司：</div>
                  <el-select v-model="page.withheldCompanyGuid" placeholder="请选择" class="ipt-sty" filterable clearable>
                    <el-option
                      v-for="item in tenantList"
                      :key="item.guid"
                      :label="item.tenantName" 
                      :value="item.guid">
                    </el-option>
                  </el-select> 
          </el-col>  
          <el-col :span="6">
          <div class="search-area-div w110">公积金状态：</div>
                  <el-select v-model="page.fundState" placeholder="请选择" class="ipt-sty" clearable>
                    <el-option
                      v-for="item in fundStateList"
                      :key="item.value"
                      :label="item.label" 
                      :value="item.value">
                    </el-option>
                  </el-select> 
          </el-col> 
          <el-col  :span="6" > 
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row> 
    </div>   
    <div class=" back-color-fff p16 mt15">
    <div class="button-area mb15" style="padding-left: 0; padding-top: 0;margin-top: 0;">
        <el-button size="medium" type="info" @click="getInsuranceDataSync">数据同步</el-button> 
        <el-button size="medium" type="info"  @click="report" v-loading.fullscreen.lock="fullscreenLoading">批量导出</el-button> 
    </div> 
      <el-table :data="tableData" border style="width: 100%;" v-loading="tableLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="staffName" label="人员" header-align="center" width="150" align="center"></el-table-column>
        <el-table-column prop="mobileNo" label="手机" header-align="center" width="150" align="center"></el-table-column> 
        <el-table-column prop="idCode" label="证件号" header-align="center" width="200" align="center"></el-table-column> 
        <el-table-column prop="insuredCompanyName" label="签约/参保公司" header-align="center" width="250" align="center"></el-table-column>
        <el-table-column prop="insuranceState" label="社保状态" header-align="center" align="center"  width="150">
              <template slot-scope="scope">{{ scope.row.insuranceState | insuranceStatus}}</template>
        </el-table-column>
        <el-table-column prop="fundState" label="公积金状态" header-align="center" align="center"  width="150">
              <template slot-scope="scope">{{ scope.row.fundState | insuranceStatus}}</template>
        </el-table-column> 
        <el-table-column prop="withheldCompanyName" label="代缴公司" header-align="center"  align="center"  width="250"></el-table-column> 
        <el-table-column label="操作" header-align="center" align="center" fixed='right'>
          <template slot-scope="scope">
            <a class="txt-color" @click="toLink(scope.row.guid)">详情</a> 
          </template>
        </el-table-column>
      </el-table> 
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>   
  </div>
</template>

<script> 
import {route}  from '@/api/apiRoute';
import store from '@/store'
export default {
  data() {
    return { 
      url:`/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
        token:{
          'Content-Type': 'multipart/form-data',
          'Authorization':store.state.token
        }, 
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0, 
        staffName: '',  
        startTime: '', 
        endTime: '', 
        insuredCompanyGuid:'',
        insuredCompanyName:'',
        withheldCompanyGuid:'',
        withheldCompanyName:'',
        levyCompanyGuid:'',
        levyCompanyName:'',
        insuranceState:'',
        fundState:'',
        freeEmploymentAgreement:'',
      }, 
        fundStateList:[
                {value:'1',label:'待参保'},
                {value:'2',label:'已参保'},
                {value:'3',label:'已删除'},
                {value:'4',label:'参保终止'},
                {value:'5',label:'待补缴'},
                {value:'6',label:'补缴成功'}, 
        ],
        tenantList:[],
        tenantListDz:[],
        tableData:[],
        sendTime:'',
        right:'right',
        fullscreenLoading: false,
        tableLoading:false
    };
  },
  created() {
    // 列表
    this.getData(false); 
    this.getTenant();
    this.getTenantDz();
    // this.getCurrentManageStaff();
  }, 
  beforeRouteEnter(to, from, next) {
    if (from.path == '/insuredManagement/insuredManagementDetails') {
      to.meta.isBack = true;
    } else {
      to.meta.isBack = false;
    }
    next();
  },
  methods: {
    getTenant() { 
      let self = this; 
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`,{'enterpriseCates':['9903','9904'],'pageSize':100}).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    }, 
    getTenantDz() { 
      let self = this; 
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`,{'enterpriseCate':'9904'}).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantListDz = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    }, 
     getInsuranceDataSync() { 
      let self = this; 
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msUserRemunerationService}/labrocontract/data/insurance-data-sync`).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.fullscreenLoading = false;
          self.$message.success("同步完成");
          self.$message.error(res.data.data.errorMsg); 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    empty() {
      let self = this; 
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0, 
        staffName: '',  
        startTime: '', 
        endTime: '', 
        insuredCompanyGuid:'',
        insuredCompanyName:'',
        withheldCompanyGuid:'',
        withheldCompanyName:'',
        levyCompanyGuid:'',
        levyCompanyName:'',
        insuranceState:'',
        fundState:'',
        freeEmploymentAgreement:'',
      };
      self.getData(true); 
    }, 
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;  
      }    
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get-insured-list`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoading = false;
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows; 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    toLink(guid){
             this.$router.push({path: "/insuredManagement/insuredManagementDetails", query:{productGuid:this.$route.query.productGuid,guid:guid}})
    },
    report(){
        let self = this;
          self.fullscreenLoading = true;
          // self.page.performanceGuid = self.$router.history.current.query.guid;
          self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/export-insured-list`, self.page).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.reportJx(res.data.data.colNames,res.data.data.datas,res.data.data.sheetName,res.data.data.fileNam);
            } else {
              self.$message.error(res.data.msg);
            }
          });
    }, 
    reportJx(colNames,datas,sheetName,fileNam){
        let self = this; 
          self.api.postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`,{'colNames':colNames,'datas':datas,'sheetName':sheetName,'fileNam':fileNam})
          .then(res => {  
             let blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
              let fileName = fileNam;
              let objectUrl = URL.createObjectURL(blob);
              const link = document.createElement('a')
              link.download = fileName;
              link.href = objectUrl;
              link.click();
          });
    },  
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
     height: 40px; 
     line-height: 40px; 
}
.el-range-editor.el-input__inner { 
     padding: 0px; 
}
/deep/ .el-checkbox__label {
    display: none;
}
.attach-sty {
    width: 170px;
    float: left; 
    margin-top: 15px;
    text-align: center;
}
.checkbox-img-sty {
    border: 1px solid #DCDFE6;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    cursor: pointer;
}
/deep/ .el-step__icon.is-text {
    border-radius: 50%;
    border-color:#4fa1a4;
    border-color: inherit;
}
/deep/ .el-step__icon-inner {
    color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
    color: #4fa1a4;
}
</style>